import { PRINT_STAMP_BUILTIN, PRINT_STAMP_COUNTS } from './printLayout';

const PREFIX = 'hr.printStampTypes';

function storageKey(prefsUserId) {
  return `${PREFIX}.${prefsUserId || 'anon'}`;
}

function createTypeId() {
  return `st-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`;
}

export function builtinStampTypes() {
  return PRINT_STAMP_COUNTS.map((n) => ({
    id: `builtin-${n}`,
    name: `${n}칸`,
    cellCount: n,
    titles: [...PRINT_STAMP_BUILTIN[n]],
    builtin: true,
  }));
}

export function loadStampTypes(prefsUserId) {
  if (typeof localStorage === 'undefined') return [];
  try {
    const raw = localStorage.getItem(storageKey(prefsUserId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((t) => t && PRINT_STAMP_COUNTS.includes(Number(t.cellCount)))
      .map((t) => ({
        id: String(t.id || createTypeId()),
        name: String(t.name || '').trim() || `${t.cellCount}칸`,
        cellCount: Number(t.cellCount),
        titles: (Array.isArray(t.titles) ? t.titles : []).map((x) => String(x || '')),
        builtin: false,
      }));
  } catch {
    return [];
  }
}

export function saveStampTypes(prefsUserId, types) {
  if (typeof localStorage === 'undefined') return;
  try {
    const list = (types || []).filter((t) => t && !t.builtin);
    localStorage.setItem(storageKey(prefsUserId), JSON.stringify(list));
  } catch {
    /* ignore */
  }
}

export function listStampTypeOptions(prefsUserId) {
  return [...builtinStampTypes(), ...loadStampTypes(prefsUserId)];
}

export function findStampType(prefsUserId, id) {
  return listStampTypeOptions(prefsUserId).find((t) => t.id === id) || null;
}

export function upsertStampType(prefsUserId, type) {
  const n = Number(type?.cellCount);
  if (!PRINT_STAMP_COUNTS.includes(n)) return null;
  const titles = (type.titles || []).map((t) => String(t || ''));
  while (titles.length < n) titles.push('');
  const saved = {
    id: type.id && !String(type.id).startsWith('builtin-') ? type.id : createTypeId(),
    name: String(type.name || '').trim() || `${n}칸`,
    cellCount: n,
    titles: titles.slice(0, n),
  };
  const rest = loadStampTypes(prefsUserId).filter((t) => t.id !== saved.id);
  saveStampTypes(prefsUserId, [...rest, saved]);
  return saved;
}

export function deleteStampType(prefsUserId, id) {
  if (!id || String(id).startsWith('builtin-')) return;
  saveStampTypes(
    prefsUserId,
    loadStampTypes(prefsUserId).filter((t) => t.id !== id)
  );
}
